<template>
    <div class="hello">

        <canvas id="scene" ref="canvas"></canvas>
    </div>
</template>

<script>
    export default {
        name: "HelloWorld",
        props: {
            msg: String
        },
        mounted() {
           
            setInterval(function () {
                initScene();
            }, 15000);
            
            var canvas = this.$refs.canvas,
                ctx = canvas.getContext("2d"),
                particles = [],
                amount = 0,
                mouse = {
                    x: 0,
                    y: 0
                },
                radius = 1;
            var scale = window.devicePixelRatio;
            ctx.scale(scale,scale);
            canvas.width = canvas.width * scale;
            canvas.height = canvas.height * scale;
            var colors = ["#D63B2F", "#D63B2F", "#B73229", "#F66257", "#F44336"];

            var copy = ['Exito', 'Welcome', 'Consult', 'Thank you', 'AI', 'Big Data'];


            var ww = canvas.width = window.innerWidth;
            var wh = canvas.height = window.innerHeight;

            function Particle(x, y) {
                this.x = Math.random() * ww;
                this.y = Math.random() * wh;
                this.dest = {
                    x: x,
                    y: y
                };
                if (window.innerWidth > 500) {
                    this.r = (Math.random() * 5) + 2 ;
                } else {
                    this.r = (Math.random() * 3);
                }
                this.vx = (Math.random() - 0.5) * 20;
                this.vy = (Math.random() - 0.5) * 20;
                this.accX = 0;
                this.accY = 0;
                this.friction = Math.random() * 0.05 + 0.94;

                this.color = colors[Math.floor(Math.random() * 6)];
            }

            Particle.prototype.render = function () {


                this.accX = (this.dest.x - this.x) / 1000;
                this.accY = (this.dest.y - this.y) / 1000;
                this.vx += this.accX;
                this.vy += this.accY;
                this.vx *= this.friction;
                this.vy *= this.friction;

                this.x += this.vx;
                this.y += this.vy;

                ctx.fillStyle = this.color;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
                ctx.fill();

                var a = this.x - mouse.x;
                var b = this.y - mouse.y;

                var distance = Math.sqrt(a * a + b * b);
                if (distance < (radius * 70)) {
                    this.accX = (this.x - mouse.x) / 100;
                    this.accY = (this.y - mouse.y) / 100;
                    this.vx += this.accX;
                    this.vy += this.accY;
                }

            }

            function onMouseMove(e) {
                mouse.x = e.clientX;
                mouse.y = e.clientY;
            }

            function onTouchMove(e) {
                if (e.touches.length > 0) {
                    mouse.x = e.touches[0].clientX;
                    mouse.y = e.touches[0].clientY;
                }
            }

            function onTouchEnd(e) {
                mouse.x = -9999;
                mouse.y = -9999;
            }

            function initScene() {
                ww = canvas.width = window.innerWidth;
                wh = canvas.height = window.innerHeight - 300;

            
              
                if (ww < 500) {
                    ctx.font = "bold " + (ww / 5) + "px sans-serif";
                } else {
                    ctx.font = "bold " + (ww / 10) + "px sans-serif";
                }

                ctx.textAlign = "center";
                ctx.fillText(copy[Math.floor(Math.random() * 6)], ww / 2, wh / 2);

                var data = ctx.getImageData(0, 0, ww, wh).data;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.globalCompositeOperation = "screen";
                var count = 150;
               
                particles = [];
                for (var i = 0; i < ww; i += Math.round(ww / count)) {
                    for (var j = 0; j < wh; j += Math.round(ww / count)) {
                        if (data[((i + j * ww) * 4) + 3] > count) {
                            particles.push(new Particle(i, j));
                        }
                    }
                }
                amount = particles.length;

            }

            function onMouseClick() {
                radius++;
                if (radius === 5) {
                    radius = 0;
                }
            }

            function render(a) {
                requestAnimationFrame(render);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                for (var i = 0; i < amount; i++) {
                    particles[i].render();
                }
            };

            //copy.addEventListener("keyup", initScene);
            window.addEventListener("resize", initScene);
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("touchmove", onTouchMove);
            window.addEventListener("click", onMouseClick);
            window.addEventListener("touchend", onTouchEnd);
            initScene();
            requestAnimationFrame(render);


        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    canvas {
        background: rgb(250, 250, 250);
        width: 100vw;
        height: 50vh;
    }
</style>
